(function () {
  'use strict';

  var LOCAL_RE = /vancouver|metro vancouver|burnaby|richmond|coquitlam|surrey|north vancouver|new westminster|british columbia|\bbc\b|canada|grant st|local pickup|repair|workshop|battery support|battery service|service-location|certified shop repair/i;

  function cleanLocalProductCopy() {
    document.querySelectorAll('.product__description p, .product__description li, .accordion__content p, .accordion__content li').forEach(function (el) {
      var text = el.textContent || '';
      var hasUnavailableLink = !!el.querySelector('a[href*="/products/iscooter-ix3-off-road"]');
      if (LOCAL_RE.test(text) || hasUnavailableLink) el.style.display = 'none';
    });

    document.querySelectorAll('.product__text, .inline-richtext').forEach(function (el) {
      var t = (el.textContent || '').toLowerCase();
      var h = el.innerHTML.toLowerCase();
      if (
        LOCAL_RE.test(t) ||
        h.indexOf('ifinancecanada.com') > -1 ||
        t.indexOf('free installation') > -1 ||
        t.indexOf('free local pickup') > -1
      ) {
        el.style.display = 'none';
      }
    });
  }

  function addUsNote() {
    var buy = document.querySelector('.product-form, product-form');
    if (buy && !document.querySelector('.pmb-us-pdp-note')) {
      var note = document.createElement('div');
      note.className = 'pmb-us-pdp-note';
      note.innerHTML =
        '<strong>United States store:</strong> Prices are shown in USD. Shipping is available within the contiguous United States. Alaska and Hawaii are not currently served.';
      buy.parentNode.insertBefore(note, buy.nextSibling);
    }
  }

  function init() {
    cleanLocalProductCopy();
    addUsNote();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();